import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material';

import {
  Popup,
  TPopupComponent,
} from '../../../../../../../shared/components/popup/popup.abstract';
import { TPopupDefaultActions } from '../../../../../../../shared/components/popup/services/popup.service';
import { CustomerCRMNote } from '../../../../../services/customer.service';
import { Content } from './content.popup';

/* The Windows note dialog (CustomersSuppliersCRMNotes) in both its modes: opened with
no note it creates one, opened with a note it edits that note's text. Titled "CRM"
there too - the dialog caption is L_CRM. */
export class AddOrEditNote extends Popup<IAddOrEditNote> {
  Component: FC<TPopupComponent>;

  constructor() {
    super();
    const stream = this.innerStream;

    this.Component = () => {
      const { t } = useTranslation();
      const SWrapper = useMemo(() => {
        return styled(this.Wrapper)(() => ({
          '& > div > div': { maxWidth: 594 },
          '& > div > div > div': { padding: 0 },
        }));
      }, []);

      return (
        <SWrapper stream={stream} popupTitle={t('customer.crm')}>
          <Content stream={stream} />
        </SWrapper>
      );
    };
  }
}

export interface IAddOrEditNote {
  action: 'save' | TPopupDefaultActions;
  values: {
    note?: CustomerCRMNote;
  };
}
